import React from "react";
import { motion } from "framer-motion";

const AboutUs = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1, transition: { duration: 1 } }}
      viewport={{ once: true }} // Add this line
      className="max-w-7xl mx-auto px-4 pb-12 sm:px-6 lg:px-8"
    >
      <div className="p-8 shadow-md rounded-lg">
        <h1 className="text-3xl font-bold text-green-700">
          Baraqah: Your Gateway to a Healthier, Happier You
        </h1>
        <p className="text-lg font-semibold mt-4">
          At Baraqah, we believe in the power of wholesome, organic food to
          nourish your body and transform your well-being. We are committed to
          providing you with the finest selection of 100% organic and fresh
          products, carefully curated to bring you the essence of nature's
          goodness.
        </p>
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-bold text-green-700">
          Embracing a Healthier Lifestyle
        </h2>
        <p className="text-lg font-semibold mt-4">
          Our journey began with a simple passion for healthy living. We
          recognized the profound impact of food on our overall health,
          vitality, and energy levels. Inspired by this realization, we embarked
          on a mission to make organic and fresh products accessible to
          everyone.
        </p>
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-bold text-green-700">
          Our Commitment to Quality
        </h2>
        <p className="text-lg font-semibold mt-4">
          We are dedicated to sourcing the highest quality organic produce from
          trusted farmers and suppliers around the globe. Our stringent
          standards ensure that our products meet the strictest organic
          certification requirements, guaranteeing you the purest and most
          wholesome ingredients.
        </p>
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-bold text-green-700">
          A Culinary Adventure
        </h2>
        <p className="text-lg font-semibold mt-4">
          Our online store is a haven for those seeking a culinary adventure
          that nourishes both body and soul. Explore our diverse range of
          organic products, from fresh fruits and vegetables to pantry staples,
          dairy alternatives, and delectable snacks.
        </p>
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-bold text-green-700">
          Your Trusted Partner in Wellness
        </h2>
        <p className="text-lg font-semibold mt-4">
          We believe in fostering a community of health-conscious individuals
          who share our passion for organic living. Our team of experts is
          always here to guide you through your journey, providing personalized
          recommendations and answering your questions with care.
        </p>
      </div>

      <div className="mt-8 text-center">
        <p className="text-lg font-semibold">
          Join us on the path to a healthier, happier you. Embrace the goodness
          of nature and experience the transformative power of Baraqah's organic
          and fresh products. Together, let's nourish our bodies, nurture our
          minds, and embrace a life filled with vitality and well-being.
        </p>
      </div>
    </motion.div>
  );
};

export default AboutUs;
